export * from './Favorites';
export * from './getPokemonInfo';
